import classes from "./NotAuthorized.module.css";
import { useNavigate } from "react-router";

const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      <div className={classes.notFoundImg} />
      <div className={classes.backBtnContainer}>
        <button className={classes.backBtn} onClick={(e) => navigate(-1)}>
          Return
        </button>
      </div>
    </div>
  );
};

export default NotAuthorized;
